import { ISplitOptions } from "../../models/text/ISplitOptions";
import { Token } from "./BuildTokens";
import { FontMetrics } from "./CanvasKerningApplier";
import { getLayoutMeasureContext, resolveLayoutMeasureAdapter } from "./layout-measure/LayoutMeasureRouter";
import { measureTokens } from "./layout-measure/measureTokens";
export type { MeasuredToken } from "./layout-measure/types";

export function LayoutMeasurer(
  tokens: Token[],
  container: HTMLElement,
  fontMetrics: FontMetrics,
  options: ISplitOptions,
): import("./layout-measure/types").MeasuredToken[] {
  const context = getLayoutMeasureContext(container);
  const adapter = resolveLayoutMeasureAdapter(container, context);
  const source = adapter.createSource(container, context);
  return measureTokens(tokens, source, fontMetrics, options);
}
